/**
 * Ссылки внутри кабинета родителя — одно место на весь кабинет (#209, PR2, PR3b).
 *
 * С PR3b кабинет живёт на сессии: адрес `/parent/<раздел>` ключа не несёт.
 * Старые адреса `/parent/<parentToken>/…` обслуживает обработчик старых
 * ссылок (`app/parent/[legacy]`).
 *
 * Переходы внутри приложения (`href`, `redirect`, `router.push`,
 * `revalidatePath`, `fetch` к `/api/parent/…`), `cta_path` уведомлений (PR3b)
 * и ссылки кабинета в письмах: `${base}${cabinetHref(…)}` (PR3c). Без сессии
 * такой адрес ведёт на вход по почте с этой же целью.
 *
 * Модуль без серверных зависимостей: его импортируют и клиентские компоненты.
 */

/** Разделы кабинета: `/parent/<раздел>`. Пустая строка — главная. */
export type CabinetSection =
  | ''
  | 'add-child'
  | 'biblioteka'
  | 'children-links'
  | 'data'
  | 'details'
  | 'email-settings'
  | 'feedback'
  | 'grade-confirm'
  | 'invite'
  | 'subscription'
  | 'upgrade';

const enc = encodeURIComponent;

/**
 * Страница кабинета. Параметры запроса — в порядке ключей объекта.
 *
 *   cabinetHref()                          → /parent
 *   cabinetHref('data')                    → /parent/data
 *   cabinetHref('', { child: id })         → /parent?child=<id>
 */
export function cabinetHref(section: CabinetSection = '', query?: Record<string, string>): string {
  const path = `/parent${section ? `/${section}` : ''}`;
  if (!query) return path;
  const qs = Object.entries(query)
    .map(([k, v]) => `${enc(k)}=${enc(v)}`)
    .join('&');
  return qs ? `${path}?${qs}` : path;
}

/** Обработчики `/api/parent/…`. Семью они берут из сессии. */
export const cabinetApi = {
  confirmGrade: (): string => '/api/parent/confirm-grade',
  notificationRead: (notificationId: string): string =>
    `/api/parent/notifications/${enc(notificationId)}/read`,
  libraryDownload: (materialSlug: string): string =>
    `/api/parent/library/${enc(materialSlug)}/download`,
};
